<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-dialog
        v-model="dialog"
        persistent
        width="50%"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            <div v-if="dialog" class="text-center py-3">
              Importing CSV file...
            </div>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-flex xs12 sm12 md10 lg8 class="d-flex mt-12">
        <!-- <label class="v-btn primary mb-10" style="padding: 6px 14px; cursor: pointer">
            <input
            type="file"
            name="file"
            @change="prepareMedia"
            id="file"
            style="display: none;"
            multiple>
            Choose CSV file
        </label> -->
        <vue-dropzone id="upload" :options="config"></vue-dropzone>
      </v-flex>
      <v-flex xs12 sm12 md10 lg8 class="d-flex mt-12">
        <v-alert
          v-model="show"
          outlined
          :type="result"
          class="my-4"
        >
          {{result_text}}
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <v-btn class="mr-3 my-2" @click="importCsv('Store')">Store</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('Food')">Food</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('Baby')">Baby</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('HealthPersonalBeauty')">HealthPersonalBeauty</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('OfficeArt')">OfficeArt</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('PatioSport')">PatioSport</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('Pet')">Pet</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('ToyElectronics')">ToyElectronics</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('PricingPro')">PricingPro</v-btn>
        <v-btn class="mr-3 my-2" @click="importCsv('PricingHabby')">PricingHobby</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import vueDropzone from "vue2-dropzone";
export default {
  components: {
    vueDropzone
  }, 
  data: () => ({
    show: false,
    result: 'success',
    result_text: '',

    dialog: false,

    product_type: '',
    filename: '',

    config: {
      url: axios.defaults.baseURL + "/upload-advanced",
      maxFiles: 1,
      addRemoveLinks: true,
      chunking: true,
      maxFilesize: 800000000,
      chunkSize: 100000,
      parallelChunkUploads: false,
      timeout: 1800000,
      retryChunks: true,
    }
  }),
  created(){
  },
  methods: {
    importCsv(product_type){
      this.dialog = true;
      axios.post('/after-csv-upload', {
        product_type: product_type,
        filename: this.filename
      })
      .then(response =>  {
        this.dialog = false;

        this.show = true;
        this.result = 'success';
        this.result_text = 'updated successfully'
      }).catch(error => {
        this.show = false;
        this.result = 'error';
      });
    },
  }
};
</script>
